import { Databases, Query, ID } from "appwrite";
import client from "../appwriteConfig";

const databases = new Databases(client);

export const PRODUCT_TYPES = {
  BEAT: "beat",
  TUTORIAL: "tutorial",
  FASHION: "fashion",
};

export const getCollectionIdByType = (type) => {
  if (type === PRODUCT_TYPES.BEAT) {
    return process.env.REACT_APP_COLLECTION_BEATS_ID;
  }

  if (type === PRODUCT_TYPES.TUTORIAL) {
    return process.env.REACT_APP_COLLECTION_TUTORIALS_ID;
  }

  if (type === PRODUCT_TYPES.FASHION) {
    return process.env.REACT_APP_COLLECTION_FASHION_ID;
  }

  throw new Error(`Unknown product type: ${type}`);
};

export const fetchSellerProducts = async (sellerEmail) => {
  const [beatsResponse, tutorialsResponse, fashionsResponse] =
    await Promise.all([
      databases.listDocuments(
        process.env.REACT_APP_DATABASE_ID,
        process.env.REACT_APP_COLLECTION_BEATS_ID,
        [Query.equal("email", sellerEmail), Query.limit(1000)],
      ),

      databases.listDocuments(
        process.env.REACT_APP_DATABASE_ID,
        process.env.REACT_APP_COLLECTION_TUTORIALS_ID,
        [Query.equal("email", sellerEmail), Query.limit(1000)],
      ),

      databases.listDocuments(
        process.env.REACT_APP_DATABASE_ID,
        process.env.REACT_APP_COLLECTION_FASHION_ID,
        [Query.equal("email", sellerEmail), Query.limit(1000)],
      ),
    ]);

  return {
    beats: beatsResponse.documents,
    tutorials: tutorialsResponse.documents,
    fashions: fashionsResponse.documents,
  };
};

export const fetchSellerCouponsApi = async (sellerEmail) => {
  const couponsResponse = await databases.listDocuments(
    process.env.REACT_APP_DATABASE_ID,
    process.env.REACT_APP_COLLECTION_COUPONS_ID,
    [Query.equal("validSellerMail", sellerEmail)],
  );

  return couponsResponse.documents;
};

export const createSellerCouponApi = async ({
  category,
  couponCode,
  discountPercent,
  sellerEmail,
}) => {
  return await databases.createDocument(
    process.env.REACT_APP_DATABASE_ID,
    process.env.REACT_APP_COLLECTION_COUPONS_ID,
    ID.unique(),
    {
      couponCode,
      discountPercent,
      category,
      validSellerMail: sellerEmail,
    },
  );
};

export const deleteCouponApi = async (couponId) => {
  return await databases.deleteDocument(
    process.env.REACT_APP_DATABASE_ID,
    process.env.REACT_APP_COLLECTION_COUPONS_ID,
    couponId,
  );
};

export const getProductDocumentApi = async (type, documentId) => {
  return await databases.getDocument(
    process.env.REACT_APP_DATABASE_ID,
    getCollectionIdByType(type),
    documentId,
  );
};

export const deleteProductDocumentApi = async (type, documentId) => {
  return await databases.deleteDocument(
    process.env.REACT_APP_DATABASE_ID,
    getCollectionIdByType(type),
    documentId,
  );
};

export const updateProductDocumentApi = async (
  type,
  documentId,
  updateData,
) => {
  return await databases.updateDocument(
    process.env.REACT_APP_DATABASE_ID,
    getCollectionIdByType(type),
    documentId,
    updateData,
  );
};
